const pricing = {
  managed_service: {
    label: 'Let Webcite help me',
    tiers: {
      launchpad: { name: 'Launchpad', price: 1200, label: '£1,200/month' },
      growth:    { name: 'Growth',    price: 2000, label: '£2,000/month' },
      partner:   { name: 'Partner',   price: 3000, label: '£3,000/month' },
    },
  },
  saas: {
    label: 'Do it myself',
    tiers: {
      starter: { name: 'Starter', price: 299, label: '£299/month' },
      growth:  { name: 'Growth',  price: 499, label: '£499/month' },
      agency:  { name: 'Agency',  price: 699, label: '£699/month' },
    },
  },
};

export default pricing;
